import { Link } from "react-router-dom";

export default function HowItWorks() {
  return (
    <aside className="bg-white/70 backdrop-blur-sm border border-gray-200 rounded-2xl p-5 shadow-sm">
      <h2 className="text-xl font-bold mb-3">Comment ça marche ?</h2>
      <ol className="space-y-3 text-sm text-gray-700 list-decimal list-inside">
        <li>
          <b>Prends un abonnement</b> : choisis le plan <b>Royal</b> (2 € / 14 jours, <b>3 000 repubs</b>).
          Tes crédits s’affichent dans le widget.
        </li>
        <li>
          <b>Télécharge & installe l’extension</b> depuis l’accueil, puis active-la dans Chrome
          (<Link to="/tutorial" className="text-blue-600 underline">Tuto</Link>).
        </li>
        <li>
          <b>Ouvre Vinted &gt; Mes annonces</b> : le widget <i>V-repop</i> apparaît en bas à gauche.
        </li>
        <li>
          <b>Connecte-toi</b> avec tes identifiants <i>V-repop</i> et <b>autorise les cookies</b>.
          <div className="text-xs text-gray-500 mt-1">
            Utilisés uniquement pour agir à ta place sur Vinted. Aucune donnée partagée à des partenaires.
          </div>
        </li>
        <li>
          <b>Vérifie ton quota</b> (sur 3 000) puis passe à <b>Étape : Modification</b> (au moins une modif photo conseillée).
        </li>
        <li>
          <b>Affiche le bouton “Republier”</b> sous tes annonces.
        </li>
        <li>
          <b>Clique</b> : une 1ʳᵉ popup (~5 s) enregistre l’annonce, une 2ᵉ crée la nouvelle & supprime l’ancienne,
          puis tout se ferme automatiquement.
          <div className="text-xs text-gray-500 mt-1">
            Autorise les pop-ups si Chrome te le demande.
          </div>
        </li>
        <li>
          <b>Enchaîne</b> : le bouton passe à “Déjà republiée” (normal, la page n’est pas rechargée). Continue sans recharger.
        </li>
      </ol>

      <div className="mt-4 flex gap-2">
        <Link
          to="/tutorial"
          className="px-3 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          Voir le tuto
        </Link>

        <a
          href="/faq.html"
          className="px-3 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium hover:bg-gray-50"
        >
          FAQ
        </a>
      </div>
    </aside>
  );
}
